export default __webpack_public_path__ + "static/media/city_square_mobile_mockup.21ce0bf6.png";